import React, {FunctionComponent} from 'react';
import './Card.less';

interface CardProps {
	style?: string //TODO use type enum
	isNoPaddings?: boolean
	className?: string
}

export const CardStyles = {
	NESTED: 'NESTED',
	PRIMARY: 'PRIMARY'
};

export const Card: FunctionComponent<CardProps> = ({children, style, isNoPaddings, className}) => {
	return (
		<div
			className={`card ${
				style === CardStyles.NESTED ? 'card--nested' : ''
			} ${
				style === CardStyles.PRIMARY ? 'card--primary' : ''
			} ${
				isNoPaddings ? 'card--no-paddings' : ''
			} ${className}`}
		>
			{children}
		</div>
	);
};
